/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import { get, map } from 'lodash';

import { uuidToDbId } from '@/graphql/utils/filters';

import { OBJECTS_QUERY, GROUPS_QUERY, PEOPLE_QUERY } from './queries';
import { objectsSearchFilter, peopleActiveRolesFilter, peopleSearchFilter } from './filters';

export const objectTypeToQuery = (objectType: string): string => {
  const objectTypeToQuery = {
    Group: GROUPS_QUERY,
    Person: PEOPLE_QUERY,
  };

  return get(objectTypeToQuery, objectType, OBJECTS_QUERY);
};

export const objectTypeToOrder = (objectType: string) => {
  return objectType == 'Person' ? { by: 'name', direction: 'ASC' } : { by: 'title', direction: 'ASC' };
};

export const searchQueryToFilter = (objectType: string, searchQuery: string) => {
  if (!searchQuery.length) return '{}';

  const peopleFilter = (searchQuery: string) => {
    if (!searchQuery) return peopleActiveRolesFilter;

    return {
      left: peopleActiveRolesFilter,
      op: {
        name: 'AND',
      },
      right: peopleSearchFilter(searchQuery),
    };
  };

  const filter = objectType == 'Person' ? peopleFilter(searchQuery) : objectsSearchFilter(searchQuery);

  return JSON.stringify(filter);
};

export const idsToFilter = (ids: string[]) => {
  const dbIds = map(ids, uuidToDbId);

  const filter = {
    left: 'id',
    op: {
      name: 'in_array',
    },
    right: dbIds,
  };

  return JSON.stringify(filter);
};
